import React, { Component } from 'react';

export default class ErrorContainer extends Component {
  render() {
    return <div>Error</div>;
  }
}
